import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const KEY = 'chathub-cookie-consent';

const readConsent = () => {
  if (typeof window === 'undefined') return 'all';
  return localStorage.getItem(KEY) || '';
};

export default function CookieBanner() {
  const { t } = useTranslation();
  const [consent, setConsent] = useState(readConsent);

  if (consent) return null;

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setConsent(value);
  };

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60] rounded-2xl border border-white/10 bg-[#0B0B0E]/95 backdrop-blur-xl p-4 shadow-2xl shadow-black/40 fade-in-up"
    >
      <div className="text-sm font-semibold text-white mb-1">{t('cookies.title')}</div>
      <div className="text-xs text-slate-400 leading-relaxed mb-3">
        {t('cookies.body')}{' '}
        <Link to="/legal/cookies" className="text-indigo-300 hover:text-indigo-200 underline">
          {t('cookies.more')}
        </Link>
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          data-testid="cookie-accept"
          onClick={() => choose('all')}
          className="flex-1 px-3 py-1.5 rounded-lg bg-indigo-500 hover:bg-indigo-600 text-white text-xs font-medium transition-colors"
        >
          {t('cookies.accept')}
        </button>
        <button
          type="button"
          data-testid="cookie-essential"
          onClick={() => choose('essential')}
          className="flex-1 px-3 py-1.5 rounded-lg bg-white/5 hover:bg-white/10 text-slate-200 text-xs font-medium border border-white/10 transition-colors"
        >
          {t('cookies.essential')}
        </button>
      </div>
    </div>
  );
}
